"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DATE_UNITS = exports.FUNCTION_CATALOG = exports.FUNCTION_DEFINITIONS = exports.ALL_FUNCTION_NAMES = exports.DATE_FNS = exports.BOOLEAN_TWO_ARG_FNS = exports.BOOLEAN_FNS = exports.CONDITIONAL_AGG_FNS = exports.MOVING_WINDOW_FNS = exports.WINDOW_FNS = exports.VARIADIC_FNS = exports.ZERO_OR_ONE_ARG_FNS = exports.THREE_ARG_FNS = exports.TWO_ARG_FNS = exports.ONE_OR_TWO_ARG_FNS = exports.SINGLE_ARG_FNS = exports.ZERO_ARG_FNS = void 0;
exports.getParserOptions = getParserOptions;
exports.ZERO_ARG_FNS = ['TODAY', 'NOW'];
exports.SINGLE_ARG_FNS = [
    'ABS',
    'CEIL',
    'CEILING',
    'FLOOR',
    'LEN',
    'LENGTH',
    'TRIM',
    'LOWER',
    'UPPER',
    'YEAR',
    'MONTH',
    'DAY',
    'LAST_DAY',
    'ISNULL',
    'SUM',
    'AVERAGE',
    'AVG',
];
exports.ONE_OR_TWO_ARG_FNS = ['ROUND', 'MIN', 'MAX'];
exports.TWO_ARG_FNS = ['LEFT', 'RIGHT', 'STRPOS', 'STARTS_WITH'];
exports.THREE_ARG_FNS = ['REPLACE', 'SUBSTRING', 'SPLIT_PART'];
exports.ZERO_OR_ONE_ARG_FNS = ['COUNT'];
exports.VARIADIC_FNS = ['CONCAT', 'COALESCE'];
exports.WINDOW_FNS = [
    'ROW_NUMBER',
    'RANK',
    'DENSE_RANK',
    'RUNNING_TOTAL',
    'NTILE',
    'FIRST',
    'LAST',
    'LAG',
    'LEAD',
];
// Window functions whose `preceding` count is a parse-time integer literal,
// validated and lifted onto the AST node like DateFn's unit.
exports.MOVING_WINDOW_FNS = ['MOVING_SUM', 'MOVING_AVG'];
exports.CONDITIONAL_AGG_FNS = ['SUMIF', 'AVERAGEIF'];
exports.BOOLEAN_FNS = ['ISNULL'];
// Two-arg functions whose result type is boolean. Reachable from BooleanAtom
// (via a dedicated grammar rule) so they parse cleanly inside `IF` conditions
// like `IF(STARTS_WITH(url, "https://"), …)`. Listed in TWO_ARG_FNS as well
// so the AST node is the same `TwoArgFnNode` shape as LEFT/RIGHT/STRPOS — the
// boolean-vs-number distinction is purely a parser-context concern, not an
// AST concern.
exports.BOOLEAN_TWO_ARG_FNS = ['STARTS_WITH'];
// Functions that take a whitelisted unit literal as one of their arguments.
// Parsed by dedicated grammar rules (like IF/SUMIF) rather than a generic
// N-arg bucket because the unit is a compile-time string validated at parse.
// DATE_SUB is a user-facing alias that desugars to DATE_ADD with negated `n`
// at parse time, so the AST only ever carries DATE_TRUNC / DATE_ADD /
// DATE_DIFF.
exports.DATE_FNS = [
    'DATE_TRUNC',
    'DATE_ADD',
    'DATE_SUB',
    'DATE_DIFF',
];
exports.ALL_FUNCTION_NAMES = [
    ...exports.ZERO_ARG_FNS,
    ...exports.SINGLE_ARG_FNS,
    ...exports.ONE_OR_TWO_ARG_FNS,
    ...exports.TWO_ARG_FNS,
    ...exports.THREE_ARG_FNS,
    ...exports.ZERO_OR_ONE_ARG_FNS,
    ...exports.VARIADIC_FNS,
    ...exports.WINDOW_FNS,
    ...exports.MOVING_WINDOW_FNS,
    ...exports.CONDITIONAL_AGG_FNS,
    ...exports.DATE_FNS,
    'COUNTIF',
    'IF',
];
// oxfmt-ignore
exports.FUNCTION_DEFINITIONS = [
    // Logical
    { name: 'IF', description: 'Conditional expression', minArgs: 2, maxArgs: 3, category: 'logical' },
    // Math
    { name: 'ABS', description: 'Absolute value', minArgs: 1, maxArgs: 1, category: 'math' },
    { name: 'ROUND', description: 'Round to decimal places', minArgs: 1, maxArgs: 2, category: 'math' },
    { name: 'CEIL', description: 'Round up to integer', minArgs: 1, maxArgs: 1, category: 'math' },
    { name: 'CEILING', description: 'Round up to integer', minArgs: 1, maxArgs: 1, category: 'math' },
    { name: 'FLOOR', description: 'Round down to integer', minArgs: 1, maxArgs: 1, category: 'math' },
    { name: 'MIN', description: 'Minimum (scalar or aggregate)', minArgs: 1, maxArgs: 2, category: 'math' },
    { name: 'MAX', description: 'Maximum (scalar or aggregate)', minArgs: 1, maxArgs: 2, category: 'math' },
    // String
    { name: 'CONCAT', description: 'Concatenate strings', minArgs: 1, maxArgs: Infinity, category: 'string' },
    { name: 'LEN', description: 'String length', minArgs: 1, maxArgs: 1, category: 'string' },
    { name: 'LENGTH', description: 'String length', minArgs: 1, maxArgs: 1, category: 'string' },
    { name: 'TRIM', description: 'Remove whitespace', minArgs: 1, maxArgs: 1, category: 'string' },
    { name: 'LOWER', description: 'To lowercase', minArgs: 1, maxArgs: 1, category: 'string' },
    { name: 'UPPER', description: 'To uppercase', minArgs: 1, maxArgs: 1, category: 'string' },
    { name: 'LEFT', description: 'Leftmost N characters', minArgs: 2, maxArgs: 2, category: 'string' },
    { name: 'RIGHT', description: 'Rightmost N characters', minArgs: 2, maxArgs: 2, category: 'string' },
    { name: 'REPLACE', description: 'Replace all occurrences of a substring (e.g. REPLACE(text, "old", "new"))', minArgs: 3, maxArgs: 3, category: 'string' },
    { name: 'SUBSTRING', description: 'Extract substring by 1-indexed start and length (e.g. SUBSTRING(text, 1, 5))', minArgs: 3, maxArgs: 3, category: 'string' },
    { name: 'SPLIT_PART', description: 'Split text on a delimiter and return the n-th part (1-indexed). E.g. SPLIT_PART(email, "@", 2) returns the domain.', minArgs: 3, maxArgs: 3, category: 'string' },
    { name: 'STRPOS', description: '1-indexed position of substring in text; 0 if not found. E.g. STRPOS("hello", "ll") returns 3.', minArgs: 2, maxArgs: 2, category: 'string' },
    { name: 'STARTS_WITH', description: 'True if text begins with prefix. E.g. STARTS_WITH(url, "https://").', minArgs: 2, maxArgs: 2, category: 'string' },
    // Date
    { name: 'TODAY', description: 'Current date', minArgs: 0, maxArgs: 0, category: 'date' },
    { name: 'NOW', description: 'Current timestamp', minArgs: 0, maxArgs: 0, category: 'date' },
    { name: 'YEAR', description: 'Extract year', minArgs: 1, maxArgs: 1, category: 'date' },
    { name: 'MONTH', description: 'Extract month', minArgs: 1, maxArgs: 1, category: 'date' },
    { name: 'DAY', description: 'Extract day', minArgs: 1, maxArgs: 1, category: 'date' },
    { name: 'LAST_DAY', description: 'Last day of the month', minArgs: 1, maxArgs: 1, category: 'date' },
    { name: 'DATE_TRUNC', description: 'Truncate a date to the start of a period ("day" | "week" | "month" | "quarter" | "year")', minArgs: 2, maxArgs: 2, category: 'date' },
    { name: 'DATE_ADD', description: 'Add an integer interval to a date (e.g. DATE_ADD(d, 3, "month"))', minArgs: 3, maxArgs: 3, category: 'date' },
    { name: 'DATE_SUB', description: 'Subtract an integer interval from a date (e.g. DATE_SUB(d, 3, "month"))', minArgs: 3, maxArgs: 3, category: 'date' },
    { name: 'DATE_DIFF', description: 'Whole-unit calendar-boundary difference between two dates (e.g. DATE_DIFF(a, b, "month") — positive when b > a)', minArgs: 3, maxArgs: 3, category: 'date' },
    // Null
    { name: 'COALESCE', description: 'First non-null value', minArgs: 1, maxArgs: Infinity, category: 'null' },
    { name: 'ISNULL', description: 'Check if null', minArgs: 1, maxArgs: 1, category: 'null' },
    // Aggregates
    { name: 'SUM', description: 'Sum values', minArgs: 1, maxArgs: 1, category: 'aggregate' },
    { name: 'AVERAGE', description: 'Average values', minArgs: 1, maxArgs: 1, category: 'aggregate' },
    { name: 'AVG', description: 'Average values', minArgs: 1, maxArgs: 1, category: 'aggregate' },
    { name: 'COUNT', description: 'Count values', minArgs: 0, maxArgs: 1, category: 'aggregate' },
    // Conditional aggregates
    { name: 'SUMIF', description: 'Sum with condition', minArgs: 2, maxArgs: 2, category: 'aggregate' },
    { name: 'AVERAGEIF', description: 'Average with condition', minArgs: 2, maxArgs: 2, category: 'aggregate' },
    { name: 'COUNTIF', description: 'Count with condition', minArgs: 1, maxArgs: 1, category: 'aggregate' },
    // Window functions
    { name: 'RUNNING_TOTAL', description: 'Running total (cumulative sum)', minArgs: 1, maxArgs: 1, category: 'window' },
    { name: 'ROW_NUMBER', description: 'Row number', minArgs: 0, maxArgs: 0, category: 'window' },
    { name: 'LAG', description: 'Previous row value', minArgs: 1, maxArgs: 3, category: 'window' },
    { name: 'LEAD', description: 'Next row value', minArgs: 1, maxArgs: 3, category: 'window' },
    { name: 'RANK', description: 'Rank with gaps', minArgs: 0, maxArgs: 0, category: 'window' },
    { name: 'DENSE_RANK', description: 'Rank without gaps', minArgs: 0, maxArgs: 0, category: 'window' },
    { name: 'NTILE', description: 'Distribute rows into buckets', minArgs: 1, maxArgs: 1, category: 'window' },
    { name: 'FIRST', description: 'First value in window', minArgs: 1, maxArgs: 1, category: 'window' },
    { name: 'LAST', description: 'Last value in window', minArgs: 1, maxArgs: 1, category: 'window' },
    { name: 'MOVING_SUM', description: 'Moving sum over preceding rows', minArgs: 2, maxArgs: 2, category: 'window' },
    { name: 'MOVING_AVG', description: 'Moving average over preceding rows', minArgs: 2, maxArgs: 2, category: 'window' },
];
const _assertAllFunctionsDefined = true;
function formatFunctionArgs(fn) {
    if (fn.maxArgs === 0)
        return '()';
    if (fn.maxArgs === Infinity)
        return '(arg1, arg2, ...)';
    const required = Array.from({ length: fn.minArgs }, (_, i) => `arg${i + 1}`).join(', ');
    const optional = fn.maxArgs > fn.minArgs
        ? `, [${Array.from({ length: fn.maxArgs - fn.minArgs }, (_, i) => `optional${i + 1}`).join(', ')}]`
        : '';
    return `(${required}${optional})`;
}
exports.FUNCTION_CATALOG = (() => {
    const byCategory = {};
    for (const fn of exports.FUNCTION_DEFINITIONS) {
        const cat = fn.category.toUpperCase();
        if (!byCategory[cat])
            byCategory[cat] = [];
        byCategory[cat].push(`  ${fn.name}${formatFunctionArgs(fn)} - ${fn.description}`);
    }
    return Object.entries(byCategory)
        .map(([cat, fns]) => `${cat}:\n${fns.join('\n')}`)
        .join('\n\n');
})();
// Unit literals accepted by date functions (DATE_TRUNC today; DATE_ADD/SUB/
// DIFF in follow-up PRs). Validated at parse time against this list.
exports.DATE_UNITS = ['day', 'week', 'month', 'quarter', 'year'];
function getParserOptions() {
    return {
        zeroArgFns: exports.ZERO_ARG_FNS,
        singleArgFns: exports.SINGLE_ARG_FNS,
        oneOrTwoArgFns: exports.ONE_OR_TWO_ARG_FNS,
        twoArgFns: exports.TWO_ARG_FNS,
        threeArgFns: exports.THREE_ARG_FNS,
        zeroOrOneArgFns: exports.ZERO_OR_ONE_ARG_FNS,
        variadicFns: exports.VARIADIC_FNS,
        windowFns: exports.WINDOW_FNS,
        movingWindowFns: exports.MOVING_WINDOW_FNS,
        conditionalAggFns: exports.CONDITIONAL_AGG_FNS,
        dateFns: exports.DATE_FNS,
        dateUnits: exports.DATE_UNITS,
        allFunctionNames: exports.ALL_FUNCTION_NAMES,
        booleanFns: exports.BOOLEAN_FNS,
        booleanTwoArgFns: exports.BOOLEAN_TWO_ARG_FNS,
    };
}
//# sourceMappingURL=functions.js.map